import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

export const renderLoading = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
    <CircularProgress />
  </Box>
);

export const renderError = (errorMsg) => (
  <Box sx={{ p: 3, textAlign: 'center' }}>
    <Typography color="error">Error: {errorMsg}</Typography>
  </Box>
);
